import {
  GET_WALK_ROUTES_REQUEST,
  GET_WALK_ROUTES_SUCCESS,
  GET_WALK_ROUTES_FAILURE,
  DELETE_WALK_ROUTE_REQUEST,
  DELETE_WALK_ROUTE_SUCCESS,
  DELETE_WALK_ROUTE_FAILURE,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const landingPagesReducer = (state = initialState, {
  type, error, data, meta, deletedId,
}) => {
  switch (type) {
    case GET_WALK_ROUTES_REQUEST:
      return { ...state, loading: true };
    case GET_WALK_ROUTES_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        total: meta.total,
        from: meta.from,
        to: meta.to,
        loading: false,
      };
    case GET_WALK_ROUTES_FAILURE:
      return { ...state, loading: false, error };
    case DELETE_WALK_ROUTE_REQUEST:
      return { ...state, loading: true };
    case DELETE_WALK_ROUTE_SUCCESS:
      return {
        ...state,
        data: state.data.filter((walkRoute) => walkRoute.id !== deletedId),
        loading: false,
      };
    case DELETE_WALK_ROUTE_FAILURE:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default landingPagesReducer;
